// @ts-nocheck
import { useEffect } from "react";

/**
 * UseEffectOnce hook
 * It runs a callback in a react component only when mounting
 * @param {function} callback
 */
export default function useEffectOnce(callback) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useEffect(callback, []);
}
